module.exports = __webpack_public_path__ + "img/zhuanxiangdati.d2509bc7.png";